import { NgClass } from '@angular/common';
import { ChangeDetectionStrategy, Component } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';

import { ApmTranslatePipe } from '@mitsubishi/core';
import { CustomCheckboxComponent } from '@mitsubishi/shared/ui';

import { FieldType, FieldTypeConfig, FormlyAttributes } from '@ngx-formly/core';

@Component({
  selector: 'apm-checkbox-type',
  templateUrl: './checkbox-type.component.html',
  styleUrls: ['./checkbox-type.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [ReactiveFormsModule, FormlyAttributes, NgClass, CustomCheckboxComponent, ApmTranslatePipe],
})
export class CheckboxTypeComponent extends FieldType<FieldTypeConfig> {
  get customProps() {
    return this.props['custom'] ?? {};
  }
}
